import { render } from "./section-four.vue?vue&type=template&id=a9f3c01c&scoped=true"
const script = {}

import "./section-four.vue?vue&type=style&index=0&id=a9f3c01c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9f3c01c"]])

export default __exports__